import React from 'react';
import { useStyletron } from 'baseui';
import { Select, SIZE as SELECT_SIZE } from 'baseui/select';
import { LabelSmall } from 'baseui/typography';
import { RELATIONSHIP_CREATOR_CONSTANTS } from '../../constants';
import { RELATIONSHIP_SELECT_OVERRIDES } from '../../overrides';
import type { SelectOptionT } from '../../types/relationship';
type RelationshipLabelSelectorProps = {
  typeOptions: SelectOptionT[];
  selectedLabelName: string;
  onTypeChange: (labelName: string) => void;
};
export const RelationshipLabelSelector = ({
  typeOptions,
  selectedLabelName,
  onTypeChange
}: RelationshipLabelSelectorProps) => {
  const [css, theme] = useStyletron();
  const selectedValue = selectedLabelName ? typeOptions.filter(o => o.id === selectedLabelName) : [];
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale300
  })}>
      <LabelSmall margin={0}>{RELATIONSHIP_CREATOR_CONSTANTS.RELATIONSHIP_TYPE_LABEL}</LabelSmall>
      <Select size={SELECT_SIZE.compact} options={typeOptions} value={selectedValue} onChange={({
      value
    }) => {
      if (value[0]) {
        onTypeChange((value[0].id as string));
      }
    }} clearable={false} overrides={RELATIONSHIP_SELECT_OVERRIDES} placeholder={RELATIONSHIP_CREATOR_CONSTANTS.SELECT_TYPE_PLACEHOLDER} />
    </div>;
};